import { IApprovedQcPlanState } from './IApprovedQcPlanState';
import { IQcPlanDetailState } from './IQcPlanDetailState';
import { IQcPlanFlagState } from './IQcPlanFlagState';
import { IQcPlanDetailOptionState } from './IQcPlanDetailOptionState';
import { McAction } from '../../IMcAction';
import { ApprovedQcPlan } from '../../../contracts/qc-plan/approved-qc-plan.model';
import { QcPlanByAnalyteOrInstrument } from '../../../contracts/qc-plan/qc-plan-detail.model';
import { QcPlanReloadFlag } from '../../../contracts/qc-plan/qc-plan-detail.model';
import { QcPlanDetailOption } from '../../../contracts/qc-plan/qc-plan-detail.model';

export function getApprovedQcPlanState(state: IApprovedQcPlanState, action: McAction): IApprovedQcPlanState {
    return Object.assign({}, state, {
        qcPlans: action.payload as ApprovedQcPlan[]
    } as IApprovedQcPlanState);
}

export function getQcPlanDetailState(state: IQcPlanDetailState, action: McAction): IQcPlanDetailState {
    return Object.assign({}, state, {
        qcPlanDetail: action.payload as QcPlanByAnalyteOrInstrument
    } as IQcPlanDetailState);
}

export function getQcPlanFlagState(state: IQcPlanFlagState, action: McAction): IQcPlanFlagState {
    return Object.assign({}, state, {
        qcPlanFlag: action.payload as QcPlanReloadFlag
    } as IQcPlanFlagState);
}

export function getQcPlanDetailOptionState(state: IQcPlanDetailOptionState, action: McAction): IQcPlanDetailOptionState {
    return Object.assign({}, state, {
        qcPlanDetailOption: action.payload as QcPlanDetailOption
    } as IQcPlanDetailOptionState);
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/qc-plan/qc-plan.reducer.logic.ts